/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Alert, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICookieComplianceViewProps } from '@msdyn365-commerce-modules/cookie-compliance/src/modules/cookie-compliance/./cookie-compliance';

const CookieComplianceView: React.FC<ICookieComplianceViewProps> = props => {
    const { CookieComplianceBanner, AlertProps, Content, acceptButton, text, links } = props;
    React.useEffect(() => {
        let cookieCompliance: any = document.querySelector('.ms-cookie-compliance__cta-layer a');
        console.log('cookie', cookieCompliance.title);
        if (cookieCompliance) {
            // @ts-ignore
            cookieCompliance.title = '';
        }
    }, []);

    return (
        <Module {...CookieComplianceBanner}>
            <Alert className={AlertProps.className} color={AlertProps.color} fade={AlertProps.fade}>
                <Node {...Content}>
                    {text}
                    {links}
                </Node>
                {acceptButton}
            </Alert>
        </Module>
    );
};
export default CookieComplianceView;
